import { MutableRefObject, useCallback } from "react";
import { useCompanionStreamingService } from "@hooks/useCompanionStreamingService";
import { HeygenAvatarService } from "@service/avatar/heygen-avatar.service";
import { EventType } from '@models/audio-message';

const useStreaming = ({
  sessionId,
  avatar,
}: {
  sessionId: string;
  avatar: MutableRefObject<HeygenAvatarService | null>;
}) => {
  const speak = useCallback(
    async (text: string) => {
      if (!avatar.current) {
        return;
      }
      await avatar.current.speak(text);
    },
    [avatar],
  );

  const { send } = useCompanionStreamingService(speak, false);

  const sendMessage = useCallback(
    async (audioBlob?: ArrayBufferLike, photoId?: string, eventType?: EventType): Promise<void> => {
      try {
        await send({
          audio: audioBlob || null,
          sessionId,
          photoId: photoId || null,
          eventType: eventType || null,
        });
      } catch (e) {
        console.error(e);
      }
    },
    [send, sessionId],
  );

  return sendMessage;
};

export default useStreaming;
